//import React components
import PropTypes from "prop-types";
import {Button, FormGroup, Input, ModalBody, Label, Form} from "reactstrap";
import {useEffect, useState} from "react";
import CustomModal from "../../../../modules/Modal/default.js";
import {useValidateForm} from "../../../../functions/Form/validate.js";
import {clone} from "ramda";
import * as yup from "yup";
import {useAppState} from "../../../../context/state.js";
import {fbLogin} from "../../../../firebase/autentication/fb_signIn.js";
import {makeAdmin} from "../../../../functions/Rights/admin/admin.js";

//import components


//Props settings for MakeUserAdmin
MakeUserAdmin.propTypes = {}

MakeUserAdmin.defaultProps = {}
export const makeAdminSchema = yup.object().shape({
    userID: yup
        .string()
        .matches(/[a-z0-9]{28}/i, "ikke gyldig user-id"),
})
export default function MakeUserAdmin({...props}) {
    const [open, setOpen] = useState(false);
    const [appState, setAppState] = useAppState();
    const [formValues, setFormValues] = useState({userID: ""});
    const {errors, handleFormSubmit, reValidate} = useValidateForm(
        makeAdminSchema,
        formValues
    );


    //runs a revalidation everytime user updates their inputs
    useEffect(() => {
        reValidate();
    }, [formValues]);


    function setProcessing(state) {
        setAppState({
            ...appState,
            processing: state
        });
    }


    const handleFieldChange = ({target: {name, value}}) => {
        const newFormValues = clone(formValues);
        newFormValues[name] = value;
        setFormValues(newFormValues);
    };
    return (
        <>
            <Button color={"warning"} onClick={() => setOpen(!open)}>Gi administrator</Button>
            <CustomModal
                size={"lg"}
                isOpen={open}
                setOpen={setOpen}
                header={"Velg bruker"}
            >
                <Form onSubmit={event => handleFormSubmit(event, async (data) => {
                    setProcessing(true);
                    makeAdmin(data.userID)
                        .then((resp) => {
                            console.log(resp.data);
                            setOpen(false);
                        })
                        .catch((err) => {
                            console.log(err.response);
                        })
                })}>
                    <ModalBody>
                        <FormGroup>
                            <Label htmlFor={"userID"}>Bruker ID</Label>
                            <Input
                                type={"text"}
                                name={"userID"}
                                onChange={handleFieldChange}
                                placeholder={"Bruker ID"}/>
                        </FormGroup>
                        <FormGroup className={"form_action"}>
                            <Button color={"success"}>Gi rettighet</Button>
                        </FormGroup>
                    </ModalBody>
                </Form>
            </CustomModal>
        </>
    )
}
